export default "__VITE_ASSET__Cvjd_OK___"